export const primitiveColors = {
	gray: {
		50: '#FFF',
		100: '#F1F4F7',
		200: '#D9E1E6',
		300: '#beccd5',
		400: '#8A9CAB',
		500: '#5E5E73',
		600: '#3D4156',
	},
	grayDark: {
		300: '#595f73',
		400: '#474c5c',
		450: '#393d4c',
		500: '#292d38',
		600: '#1f2129',
	},
	primary: {
		500: '#786AFF',
		400: '#8986F3',
	},
	secondary: {
		500: '#2CC0D3',
		600: '#2CC0D3',
	},
	accent: {
		500: '#F9AA43',
		// Смесь 500/600 (30/70), как в default.
		550: '#E89014',
		600: '#E08500',
	},
	success: { 500: '#2CC0D3' },
	error: { 500: '#FF4F69' },
	alpha: {
		black25: 'rgba(0, 0, 0, 0.25)',
		primary20: 'rgba(120, 106, 255, 0.2)',
		secondary20: 'rgba(44, 192, 211, 0.2)',
		accent20: 'rgba(250, 194, 72, 0.2)',
		error20: 'rgba(250, 112, 121, 0.2)',
	},
	gradient: {
		primary: 'linear-gradient(308.92deg, #C4B5FD -1.36%, #9B7EDE 92.91%)',
		green: 'linear-gradient(105.44deg, #55CF88 2.25%, #CBE994 100%)',
		orange: 'linear-gradient(105.44deg, #FB9F6C 2.25%, #FFCF58 100%)',
		purple: 'linear-gradient(105.44deg, #BA68C8 2.25%, #FFB7D6 100%)',
	},
	testBg: {
		primary: '#5f5e7b',
		secondary: '#6B6FBC',
		brightDark: '#48467A',
		darkBlue: '#29549C',
		brightGreen: '#3C9AB1',
		neutral: '#595A5D',
	},
	scale: {
		level1: '#ade28d',
		level2: '#d3d966',
		level3: '#f7ce52',
		level4: '#ffe493',
		level5: '#ffedb8',
		level6: '#fff5d9',
	},
} as const;
